
import { defineComponent } from 'vue';
import NFTCard from '@/components/gem-bank/NFTCard.vue';

export default defineComponent({
  components: { NFTCard },
  emits: ['selected'],
  props: {
    title: String,
    nfts: Array,
    info: Boolean,
    farmerState: String,
    staking: Boolean,
    move: Boolean,
    notSelected: Boolean,
    number: String,
    only: Boolean,
  },
  setup(props, ctx) {
    const handleSelected = (e: any) => {
      if (props.notSelected) return
      if (props.only) return
      console.log('paso de clikc selected')
      ctx.emit('selected', e);
    };
    return {
      handleSelected,
    };
  },
});
